import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      color: palette.text.secondary,
      fontWeight: 600
    },
    default: {
      gap: '10px',
      fontSize: '0.875rem'
    },
    recapCommande: {
      gap: '5px',
      fontSize: '0.875rem'
    },
    text: {
      color: palette.text.primary,
      fontWeight: 700
    },
    textdefault: {
      fontSize: '1.25rem'
    },
    textrecapCommande: {
      fontSize: '1rem',
      wordBreak: 'break-all'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
